import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock3 } from "lucide-react";
import { BLOG_POSTS } from "@/lib/site-data";

const ease = [0.22, 1, 0.36, 1];

export default function BlogTeaser() {
  return (
    <section id="conseils" data-testid="blog-teaser-section" className="relative border-t border-white/5 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-terra">Le blog du couvreur</p>
            <h2 className="mt-4 max-w-xl font-serif text-3xl font-semibold leading-tight text-white md:text-5xl">
              Conseils toiture, par ceux qui montent dessus
            </h2>
          </div>
          <Link
            to="/conseils"
            data-testid="blog-teaser-all"
            className="group inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-terra transition-colors hover:text-terra-hover"
          >
            Tous les conseils
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {BLOG_POSTS.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.6, ease }}
            >
              <Link
                to={`/conseils/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group flex h-full flex-col border border-white/5 bg-[#14171D] p-6 transition-colors duration-300 hover:border-terra/40"
              >
                <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
                  <span className="text-terra">{p.cat}</span>
                  <span className="flex items-center gap-1.5">
                    <Clock3 className="h-3 w-3" />
                    {p.read}
                  </span>
                </div>
                <h3 className="mt-4 flex-1 font-serif text-lg leading-snug text-slate-100 transition-colors group-hover:text-terra">
                  {p.title}
                </h3>
                <p className="mt-3 line-clamp-3 text-xs leading-relaxed text-slate-400">{p.intro}</p>
                <span className="mt-5 inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-slate-400 transition-colors group-hover:text-terra">
                  Lire l'article
                  <ArrowUpRight className="h-3.5 w-3.5" />
                </span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
